export default __webpack_public_path__ + "static/media/donorsearch_logo.e27eefdc.png";